module.exports = __webpack_public_path__ + "img/Hyundai.3b003a91.png";